// Place IDs that get the new analytics UI (Ultra Admin/Super Admin/Admin) and,
// by extension, the new Patient Reports search/filter UI.
export const GRAPH_PLACE_IDS = [
  8815, 5411, 8413, 8445, 8446, 8447, 8448, 8449, 8450, 8451, 8453, 8454, 8455,
  8456, 8457, 8494, 8495, 8496, 8498, 8499, 8500, 8501, 8502, 8503, 8504, 8505,
  8506, 8507, 8508, 8509, 8511, 8512, 8514, 8515, 8516, 8517, 8518, 8519, 8520,
  8521, 8522, 8528, 8541, 8542, 8543, 8544, 8545, 8546, 8547, 90001, 90002,
  90003, 90004, 90005, 90006, 90007, 90008
];

export const isGraphPlaceId = (placeId) => GRAPH_PLACE_IDS.includes(Number(placeId));

//Tabular-Graph view
export const TABULAR_VIEW_PLACE_IDS = [8331, 8961, 8960];

export const isTabularViewPlace = (placeId) => TABULAR_VIEW_PLACE_IDS.includes(Number(placeId));
